// extracted by mini-css-extract-plugin
module.exports = {"root":"TransportTenantBtn_root__3R4T-"};